import AvitoTab from './AvitoTab';

export default AvitoTab;